import React from 'react';
import 'dayjs/locale/en-gb';
import {BoolDictionary} from "../custom_types/customTypes";
import ConfirmDialog from "./ConfirmDialog";
import {AmountInput} from "../form_inputs/AmountInput";
import {PaidAtInputProps} from "../form_inputs/PaidAtInput";
import {DateInput} from "../form_inputs/DateInput";
import moment from "moment/moment";
import { GetOneResult, useDataProvider} from 'react-admin';

const RepayLoanDialog = (props: {
    id: string; icon: any; button_type: "list" | "show";
    fields: any
}) => {

    const id = props.id
    const button_type = props.button_type

    let data: GetOneResult<any>
    let amount = ""
    let principal = ""
    let interest = ""

    const dataProvider = useDataProvider();

    const changeFigures = async (paid_at: any, onChange: any) => {
        const params = { id: id, meta: {at_date: paid_at.format('YYYY-MM-DD HH:mm:ss')} }
        data = await dataProvider.getOne('vault/loan/loans/<id>/loan_settlement_values', params);
        amount = data.data.amount
        principal = data.data.principal
        interest = data.data.interest

        document.querySelectorAll("input").forEach(function (el) {
            if (el.name === "amount") {
                el.value = amount
                onChange("amount")(amount, false)
            }
            if (el.name === "principal") {
                el.value = principal
                onChange("principal")(principal, false)
            }
            if (el.name === "interest") {
                el.value = interest
                onChange("interest")(interest, false)
            }
        });
        onChange("paid_at")(paid_at, false)
    }

    const handleClickOpen = async (onChange:any) => {
        await changeFigures(moment(), onChange)
    }

    const RepayLoanPaidAtInput = (props: PaidAtInputProps) => {
        const  {onChange, error} = props

        const handleChange = async (pickerData: any) => {
            const paid_at = moment(pickerData.toDate())
            await changeFigures(paid_at, onChange)
        }
        return (
            <DateInput label="Paid At" name="paid_at"
                           onChange={handleChange}
                           error={error}
                           defaultValue={ button_type === "show" ? moment().toDate() : null }
            />
        )
    }

    const getInitValues = () => {
        return {
            "amount": amount,
            "principal": principal,
            "interest": interest,
            "paid_at": moment()
        }
    }

    const DialogField = (props: { fieldKey: string, onChange: any, error: boolean }) => {
        if (props.fieldKey === "amount") {
            return (<AmountInput {...props}
                                 value={amount}
                                 disabled={true}
                                 label="Amount"
            />)
        }
        if (props.fieldKey === "principal") {
            return (<AmountInput {...props}
                                 value={principal}
                                 disabled={true}
                                 id="principal"
                                 name="principal"
                                 placeholder="Principal"
                                 label="Principal"
            />)
        }
        if (props.fieldKey === "interest") {
            return (<AmountInput {...props}
                                 value={interest}
                                 disabled={true}
                                 id="interest"
                                 name="interest"
                                 placeholder="Interest"
                                 label="Interest"
            />)
        }
        return (<RepayLoanPaidAtInput {...props} />)
    }

    const getParams = (id: any, values: any) => {
        return {
            data: {
                amount: amount,
                principal: principal,
                interest: interest,
                paid_at: values['paid_at'],
                transaction_type: "REPAYMENT"
            }
        }
    }

    let getFormFields = (fields: any, getOnChange: any, errors: BoolDictionary) => {
        return fields.map((fieldKey: string) => (
            <DialogField fieldKey={fieldKey} onChange={getOnChange} error={errors[fieldKey]} key={fieldKey} />
        ));
    }

    let getConfirmDisabled = (values: any) => {
       let msg = ""
       if (values['amount'] === '0.00') {
           msg += "Transaction amount can not be £0.00. ";
       }
       if (values["paid_at"].format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
            msg += "Transaction date can not be in the future."
        }
       return msg
    }

    return (<ConfirmDialog {...props}
                           getConfirmDisabled={getConfirmDisabled}
                           handleClickOpen={handleClickOpen}
                           getInitValues={getInitValues}
                           getParams={getParams}
                           getFormFields={getFormFields}
                           data_provider_endpoint={"vault/loanaccount/transactions/" + props.id}
                           data_provider_call_type="create"
                           label="Repay Loan"
                           contracted={false}
                           formValidationAlert={"Please enter loan settlement date/time"}
                           requestErrorMessage="An unexpected error occurred when posting loan settlement. Please report this issue to engineering."
                           redirectTo={'/vault/loan/loans/' + props.id + '/show/transactions/*'}
        />
    )
}

export default RepayLoanDialog